import { useEffect } from "react";
import { userManager } from "../../../auth/oidcConfig";

export default function SilentRenew() {
  useEffect(() => {
    async function handleSilentCallback() {
      try {
        await userManager.signinSilentCallback();
      } catch (err) {
        console.error("❌ Silent renew error:", err);
      }
    }

    handleSilentCallback();
  }, []);

  // This is never shown (runs in hidden iframe)
  return <div>Silent renew in progress...</div>;
}
